import React from 'react';
import { cn } from '@/lib/utils';

const FeatureChip = ({ icon: Icon, label, sub }) => (
  <div
    role="listitem"
    className="landing-bento-surface flex aspect-square w-[112px] shrink-0 snap-start flex-col justify-between p-3 sm:w-[124px]"
  >
    <Icon size={18} weight="duotone" className="text-primary" />
    <div>
      <p className="text-[13px] font-semibold leading-tight text-neutral-900">{label}</p>
      {sub ? <p className="mt-0.5 text-[11px] leading-snug text-neutral-500">{sub}</p> : null}
    </div>
  </div>
);

export const FeatureChipScroller = ({ tiles, label, className }) => (
  <div
    role="list"
    aria-label={label}
    className={cn(
      'overflow-x-auto overscroll-x-contain pb-1',
      'snap-x snap-mandatory touch-pan-x',
      '[scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden',
      '-mr-4 pr-4 sm:-mr-6 sm:pr-6 lg:hidden',
      className,
    )}
  >
    <div className="flex w-max gap-2">
      {tiles.map((tile) => (
        <FeatureChip key={tile.label} {...tile} />
      ))}
    </div>
  </div>
);

export const FeatureListGrid = ({ tiles, className, columns = 3 }) => (
  <div
    className={cn(
      'landing-bento-surface hidden overflow-hidden rounded-2xl border border-neutral-200 bg-neutral-200 lg:grid',
      'gap-[1px]',
      columns === 6 ? 'lg:grid-cols-6' : columns === 4 ? 'lg:grid-cols-4' : 'lg:grid-cols-3',
      className,
    )}
  >
    {tiles.map((tile) => {
      const Icon = tile.icon;
      return (
        <div key={tile.label} className={cn('bg-white p-5 sm:p-6', columns >= 5 && 'lg:p-4')}>
          <Icon size={20} weight="duotone" className="mb-3 text-primary" />
          <p className="landing-card-label">{tile.label}</p>
          <p className="landing-card-meta mt-1">{tile.sub}</p>
        </div>
      );
    })}
  </div>
);
